import React from 'react';
import PropTypes from 'prop-types';

import { PSPReview } from 'components/molecules';

import './PSPReviewCard.scss';

export function PSPReviewCard({ reviews, pageType }) {
	return (
		<div className="reviews-content">
			{reviews.map((review) => (
				<PSPReview
					{...review}
					key={review.reviewTitle}
					pageType={pageType}
				/>
			))}
		</div>
	);
}

PSPReviewCard.propTypes = {
	reviews: PropTypes.arrayOf(
		PropTypes.shape({
			reviewTitle: PropTypes.string.isRequired,
			reviewRating: PropTypes.number.isRequired,
			reviewText: PropTypes.string.isRequired,
			reviewerInitials: PropTypes.string.isRequired,
			reviewerImage: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.object,
			]).isRequired,
			reviewerName: PropTypes.string.isRequired,
			reviewDate: PropTypes.string.isRequired,
		})
	).isRequired,
		pageType: PropTypes.string,
	};
	
PSPReviewCard.defaultProps = {
	pageType: "PSP",
};
export default PSPReviewCard;
